import styled from 'styled-components';
import {
  mediumGreen,
  fontFamilyRoboto,
} from '@components/hoc/Theme/Theme.styled';

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: auto;
  width: 90%;
  gap: 15px;
`;
export const MultiStepFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 auto;
  width: 100%;
  @media (max-width: 480px) {
    padding: 0;
    padding-top: 1rem;
  }
`;

export const PreviousStep = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  margin-left: 3.5%;
  margin-right: auto;
  font-size: 16px !important;
  font-family: ${fontFamilyRoboto};
  color: #000 !important;
  text-decoration: none !important;
  &:before {
    font-size: 28px !important;
    font-family: ${fontFamilyRoboto};
    color: ${mediumGreen};
    content: '';
  }
  &:hover {
    text-decoration: underline !important;
  }
`;
